import initialState from "./initialState";
const state= initialState();
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/common/state.js